import { useCallback, useEffect, useState } from "react";
import {
  fetchSurfCredits,
  fetchSurfUsageBreakdown,
  formatCreditsBalance,
  type SurfAccountCredits,
  type SurfUsageBreakdown,
} from "@vida/surf-core";
import { getAdminApiBaseUrl } from "../services/surfAdminApi";
import { ensureSurfClientConfig } from "../services/surfClientConfig";
import { getIdToken } from "../auth";

export function useSurfAccountSummary() {
  const [credits, setCredits] = useState<SurfAccountCredits | null>(null);
  const [usage, setUsage] = useState<SurfUsageBreakdown | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      await ensureSurfClientConfig();
      const base = getAdminApiBaseUrl();
      if (!base) {
        setCredits(null);
        setUsage(null);
        setError("Crediti non disponibili (admin-api non configurato).");
        return;
      }
      const cfg = { adminApiBaseUrl: base, getIdToken };
      const [nextCredits, nextUsage] = await Promise.all([
        fetchSurfCredits(cfg),
        fetchSurfUsageBreakdown(cfg, 30),
      ]);
      setCredits(nextCredits);
      setUsage(nextUsage);
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const balanceLabel = credits ? formatCreditsBalance(credits.balanceCents) : "—";

  return { credits, usage, balanceLabel, loading, error, refresh };
}
